<style scoped>
  a.paginate_button.current {
    background: black !important;
  }
  input[type="search"] {
    border: 1.5px solid #d8dbe0;
    border-radius: 4px;
    padding: 5px;
  }
</style>

<template>
  <CCard>

    <CCardHeader style="background:#1a3665;color:white" class="d-flex align-items-center font-weight-bold">
      Master Divisi   
      <template v-if="role_status && role_status.status_create">
      <CButton
        color="success"        
        class="btn-md ml-auto button-md-block px-3"
        @click="createData">Tambah</CButton>
      </template>
      <template v-else>
        <CButton
        color="secondary"        
        class="btn-md ml-auto button-md-block px-3"
        disabled
        >Tambah</CButton>
      </template>  
    </CCardHeader>

    <CCardBody>
      <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left "
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
            @keyup="cariData"
          />
        </CCol>
        
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{ index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>

            <template #namaDivisi="{item}">
              <td class="py-2 text-left">{{item.namaDivisi ? item.namaDivisi : "-"}}</td>
            </template>
            
            <template #status="{item}">
              <td class="py-2 text-center">
                <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 text-center">
                <template v-if="role_status && role_status.status_update">
                  <CButton v-c-tooltip="'Ubah'" color="info" square size="sm" @click="updateData(item, index)">
                    <font-awesome-icon icon="edit" />
                  </CButton>&nbsp;&nbsp;
                </template>
                <template v-else>
                  <CButton v-c-tooltip="'Ubah'" color="secondary" square size="sm" disabled >
                    <font-awesome-icon icon="edit" />
                  </CButton>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" square size="sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Hapus'" color="readonly" square size="sm" disabled>
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>

      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"        
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <CCol sm="12 mb-3">
              <label for="nama_divisi" class="font-weight-bold">Nama Divisi</label>
              <input
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': $v.formData.namaDivisi.$error,                   
                }"
                id="nama_divisi"
                placeholder="Masukkan Nama Divisi"                  
                v-model="formData.namaDivisi"
                aria-required="true"   
                @input="setNamaDivisi($event.target.value)"
              />                                               
            </CCol>

            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"                    
                    name="customRadio"
                    id="aktif"
                    value="1"
                    v-model="formData.status"
                    aria-required="true"
                    checked
                  />
                  <label class="custom-control-label" for="aktif">Aktif</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="tidak_aktif"
                    value="0"
                    v-model="formData.status"
                  />
                  <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                </div>                
              </div>
              <span v-if="$v.formData.status.$error" class="text-danger">
                *Mohon pilih status
              </span>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{title}}</h6>          
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
  </CCard>
</template>
<script>
import { required } from "vuelidate/lib/validators";

import DivisiService from "../../services/datamaster/divisi.service";
import { AlertUtils } from "../../mixins/AlertUtils"

const fields = [
  { key: "no", _style: "width: 8%" },
  {
    key: "namaDivisi",
    _style: "text-align: left; width: 40%"
  },  
  { key: "status", _style: " text-align: center" },
  { key: "aksi", _style: "width:15%; text-align: center" }
];

export default {
  name: "Divisi",
  mixins : [AlertUtils],
  data() {
    return {
      search: "",
      items: [],
      actionPost: "",
      pageSize: "10",
      formData: {
        namaDivisi: "",
        status: "",
        idDivisi: ""
      },
      pagination: {
        totalPages: 0
      },
      fields,
      title : '',
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      indexed: 0,
      collapseDuration: 0,
      content: [],
      timeout : null,
      awaitingSearch : false,
      role_status: null,
    }
  },
  validations: {
    formData: {
      namaDivisi: { required },
      status: { required }
    },
  },
  mounted() {
    this.roleData();
    this.getData("0", this.pageSize, "default");
    // comment console console.log(this.pageSize);
  },
  watch: {
    // search: function (val) {
    //   if (!this.awaitingSearch) {
    //     setTimeout(() => {
    //       this.awaitingSearch = false;
    //       this.getData("0", this.pageSize, this.search);
    //     }, 1000); // 1 sec delay
    //   }
    //   this.awaitingSearch = true;
    // },
    currentPage: function(val) {
      // alert(val-1);
      var page = val - 1;
      this.indexed = page * 10;
      // alert(this.indexed);
      this.getData(val - 1, this.pageSize, this.search);
      // this.getData(val-1);
    },
    myModal: function() {
      this.$v.$reset();
      document.getElementById("nama_divisi").classList.remove("is-valid")
    }
  },
  methods: {
    setNamaDivisi(value) {
      this.formData.namaDivisi = value;   
      this.$v.formData.namaDivisi.$touch();   
      if(!this.$v.formData.namaDivisi.$error) {
        document.getElementById("nama_divisi").classList.add("is-valid")
      } 
    },

    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },

    cariData() {
       // clear timeout variable
      clearTimeout(this.timeout);
      var vm = this
      this.timeout = setTimeout(function () {
          // enter this block of code after 1 second
          // handle stuff, call search API etc.
          vm.getData("0", vm.pageSize, vm.search);
      }, 1000);
    },

    pageChange() {
      // this.getData(currentPage);
      this.getData(currentPage, this.pageSize, this.search);
    }, 
    
    deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            DivisiService.deleteDivisi(this.formData)
              .then(response => {
                // comment console console.log(response);
                this.alertDeleteSuccess();
                // this.getData("1");
                this.getData("0", this.pageSize, this.search);
              })
              .catch(error => {
                this.alertError();
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, filter) {
      if (filter == "") {
        filter = "default";
      }
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      DivisiService.getDivisi(currentPage, pageSize, filter)
        .then(response => {
          // comment console console.log(response.data);

          // comment console console.log(response.data.data.content);
          this.items = response.data.data.content;
          // // comment console console.log("ini data cabang")
          // // comment console console.log(items);
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
          loader.hide();
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },

    createData() {
      this.myModal = true;
      this.formData = {};
      this.actionPost = "insert";
      this.title = "Tambah";      
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.actionPost = "update";
      this.title = "Edit";      
    },

    postData() {
      this.$v.$touch();
      if (this.actionPost == "insert") {        
        if (this.$v.$invalid) {
          return;
        } else {          
          this.insertData(this.formData);          
        }        
      } else if (this.actionPost == "update") {
        if (this.$v.$invalid) {
          return;
        } else {          
          this.putData();
        }                
      }
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      
      var vm = this;
      DivisiService.postDivisi(formData)
        .then(response => {
          loader.hide();
          vm.myModal = false;
          vm.$v.$reset();
          document.getElementById("nama_divisi").classList.remove("is-valid")
          vm.alertSuccess();
          vm.getData("0", this.pageSize, this.search);
        })
        .catch(error => {
          loader.hide();          
          vm.alertError(error.response.data.message);
        });
    },

    putData() {      
      var vm = this;
      DivisiService.putDivisi(this.formData)
        .then(response => {
          vm.myModal = false;
          vm.$v.$reset();
          document.getElementById("nama_divisi").classList.remove("is-valid")
          vm.alertEditSuccess();
          vm.getData("0", this.pageSize, this.search);          
        })
        .catch(error => {
          // comment console console.log(error);
          // comment console console.log(error.response.data.message);

          vm.alertError(error.response.data.message);
        });
    },    
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    }
    
  }
};
</script>